import { APIResponse } from '../models/api-response.model';
import { APIServiceService } from './apiservice.service';
import { User } from '../models/user.model';
import { Observable, observable } from 'rxjs';

export class UserEndpoint {

  constructor(private apiService: APIServiceService) {}

  async login(token: string): Promise<APIResponse> {
    try {
      const response = await this.apiService.doGET('user/login', token, false).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async authenticateToken(token: string): Promise<APIResponse> {
    try {
      const response = await this.apiService.doGET('user/authenticate/token', token, false).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async create(user: User): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST('user', token, user).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getEmailAvailability(email: string): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET('user/email', token, { email }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getGCalEventsWithinDates(startDate: string, endDate: string): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET('user/gcalevents', token, { startDate, endDate }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getMeta(metaKey: string): Promise<any> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET('user/meta', token, { metaKey }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  isEmailtaken(email: string): Observable<any> {
    return new Observable((obs) => {
      this.apiService.getCurrentUserToken().then(token => {
        if (!token) {
          obs.error('no_auth_token');
          return;
        }
        this.apiService.doGET('user/email', token, { email }).subscribe(response => {
          obs.next(response);
          obs.complete();
        });
      }).catch(() => {
        obs.error('no_auth_token');
      });
    });
  }
  

}
